import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { RadioTowerIcon } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
export function ProtectedRoute({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    session,
    loading
  } = useAuth();
  const location = useLocation();
  if (loading) {
    return <div className="min-h-screen w-full flex flex-col items-center justify-center gap-4" data-id="element-441" data-mp="93o8pcyqdsxm">
        <div className="relative" data-id="element-442" data-mp="wt8r9uqz2o6d">
          <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-cyan-400 to-blue-600 flex items-center justify-center shadow-glow" data-id="element-443" data-mp="10uc5kctdgc5h">
            <RadioTowerIcon size={22} className="text-white" strokeWidth={2.4} data-id="element-444" data-mp="mthutniupz3n" />
          </div>
          <div className="absolute -inset-2 rounded-2xl bg-cyan-400/20 blur-xl -z-10 animate-breathe" data-id="element-445" data-mp="rsupgufysags" />
        </div>
        <div className="flex items-center gap-2" data-id="element-446" data-mp="37k0l3etgkykt">
          <span className="pulse-dot bg-cyan-400 text-cyan-400" data-id="element-447" data-mp="3cjv6j2ugsvyh" />
          <span className="text-xs text-slate-500 font-mono tracking-wider uppercase" data-id="element-448" data-mp="3cl6ezfyuurvx">
            Authenticating session…
          </span>
        </div>
      </div>;
  }
  if (!session) {
    return <Navigate to="/login" replace state={{
      from: location
    }} data-id="element-449" data-mp="39fqrgxsfu9df" />;
  }
  return <>{children}</>;
}